import { FunctionComponent } from 'react';
import styles from "./TextHeader.module.css";
import cn from 'classnames';

interface ITextHeaderProps {
    title: string;
    summary?: string;
    className?: string;
};

const TextHeader: FunctionComponent<ITextHeaderProps> = ({title, summary, className }) => {
    return (
        <div className={cn(styles.textHeader, className)}>
            <div className={styles.textTitle}>{title}</div>
            {summary && <div className={styles.textSummary}>{summary}</div>}
        </div>
    );
};

export default TextHeader;
